export default function scrollPositionFix() {
  if (!window.location.hash) {
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/services/scroll_position_fix.js